(() => {
 if(customElements.get('spotec-career'))return;
 customElements.define('spotec-career',class extends HTMLElement{
  connectedCallback(){
   if(this.abort)return;this.abort=new AbortController();const opts={signal:this.abort.signal};
   this.addEventListener('click',event=>{
    const button=event.target.closest('[data-job-open]');
    if(button){const dialog=this.querySelector('#'+CSS.escape(button.dataset.jobOpen));this.openJob(dialog,button);}
    if(event.target.closest('[data-job-close]'))this.active?.close();
   },opts);
   this.querySelectorAll('dialog').forEach(dialog=>{
    dialog.addEventListener('close',()=>this.restore(dialog),opts);
    dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();},opts);
   });
   this.addEventListener('shopify:block:select',event=>{const dialog=event.target.querySelector('dialog');if(dialog)this.openJob(dialog,event.target.querySelector('[data-job-open]'));},opts);
   this.addEventListener('shopify:block:deselect',()=>this.active?.close(),opts);
   window.addEventListener('pagehide',()=>{this.active?.close();this.restore(this.active);},opts);
  }
  openJob(dialog,button){
   if(!dialog||dialog.open||typeof dialog.showModal!=='function')return;
   if(this.active){const old=this.active;old.close();this.restore(old);}
   if(document.querySelector('dialog[open]'))return;
   this.active=dialog;this.returnFocus=button;this.previousOverflow=document.documentElement.style.overflow;
   dialog.showModal();document.documentElement.style.overflow='hidden';
   document.dispatchEvent(new CustomEvent('spotec:popup-toggle'));
  }
  restore(dialog){
   if(!this.active||dialog!==this.active)return;
   document.documentElement.style.overflow=this.previousOverflow;
   this.returnFocus?.focus({preventScroll:true});this.active=null;
   document.dispatchEvent(new CustomEvent('spotec:popup-toggle'));
  }
  disconnectedCallback(){const dialog=this.active;dialog?.close();this.restore(dialog);this.abort?.abort();this.abort=null;}
 });
})();
